<template>
  <BaseButton ghost small @click="open">
    <span class="truncate"> Delete </span>
  </BaseButton>
</template>

<script>
import { contactAccProductReactionsClient } from '@/api/clients';

export default {
  props: {
    accProductReaction: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showForm: false,
    };
  },
  methods: {
    async open() {
      this.$modal.show({
        component: () => import('Components/AccProductReactions/AccProductReactionDeleteModal.vue'),
        props: {
          action: contactAccProductReactionsClient.destroy,
          accProductReaction: this.accProductReaction,
        },
        on: {
          'acc-product-reaction-deleted': (accProductReaction) => {
            this.$emit('acc-product-reaction-deleted', accProductReaction);
          },
        },
        hideEvent: 'hide',
      });
    },
  },
};
</script>
